import * as angular from "angular";

angular
  .module('bringoz.admin.accounts', [
    'bringoz.admin.commons',
    'bringoz.admin.deliveries',
    'bringoz.admin.commissions',
    'bringoz.admin.agents',
    'bringoz.admin.shippers'
  ]);
